<td colspan="99">
  <div class="text-center">
    <div class="my-5">
      <i class="fad fa-feather-alt fa-{{ size }} text-muted mb-4"></i>
      <h3 class="text-muted font-weight-light">
        <span>{{ content }}</span>
      </h3>
      <button
        type="button"
        [routerLink]="ctaRouterLink"
        class="btn btn-outline-primary mt-3"
      >
        {{ cta }}
      </button>
    </div>
  </div>
</td>
